"use client";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0b0b10] text-white">
      <div className="mx-auto w-full max-w-4xl px-6 py-16">
        <p className="text-[10px] uppercase tracking-[0.3em] text-white/60">
          Legal
        </p>
        <h1 className="mt-3 text-3xl font-heading text-white">Privacy Policy</h1>
        <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/70">
          <p className="font-medium text-white/80">Effective date</p>
          <p className="mt-1">January 1, 2026</p>
        </div>

        <div className="mt-10 space-y-4 text-sm leading-relaxed text-white/70">
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">1. Overview</h2>
            <p className="mt-3">
              This Privacy Policy explains how Hopp collects, uses, shares, and
              protects information when you use our websites, apps, and related
              services (collectively, the &ldquo;Services&rdquo;). By using the Services,
              you agree to the practices described here.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              2. Information We Collect
            </h2>
            <p className="mt-3">
              We collect information you provide directly and information
              collected automatically when you use the Services.
            </p>
            <ul className="mt-3 list-disc space-y-2 pl-5 marker:text-white/50">
              <li>
                Account data such as name, email, phone number, and profile
                details.
              </li>
              <li>
                Event activity such as RSVPs, ticket purchases, attendance
                history, and host communications.
              </li>
              <li>
                Payment data processed by our payment providers (we do not store
                full card details).
              </li>
              <li>
                Device and usage data such as IP address, browser type, device
                identifiers, pages viewed, and log activity.
              </li>
              <li>
                Support communications and feedback you send to us.
              </li>
            </ul>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              3. Cookies and Analytics
            </h2>
            <p className="mt-3">
              We use cookies and similar technologies to operate the Services,
              remember preferences, and understand usage trends. You can control
              cookies through your browser settings, but some features may not
              work properly without them.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              4. How We Use Information
            </h2>
            <p className="mt-3">
              We use information to provide and improve the Services, process
              transactions, communicate with you, and keep the community safe.
              Common uses include:
            </p>
            <ul className="mt-3 list-disc space-y-2 pl-5 marker:text-white/50">
              <li>Creating and managing accounts.</li>
              <li>Facilitating event discovery, RSVPs, and ticketing.</li>
              <li>Sending confirmations, reminders, and service updates.</li>
              <li>Detecting fraud, abuse, or security incidents.</li>
              <li>Improving product performance and user experience.</li>
              <li>
                Providing marketing communications when permitted by your
                preferences and applicable law.
              </li>
            </ul>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              5. How We Share Information
            </h2>
            <p className="mt-3">
              We share information only as needed to operate the Services:
            </p>
            <ul className="mt-3 list-disc space-y-2 pl-5 marker:text-white/50">
              <li>
                With hosts to manage guest lists, approvals, and event logistics.
              </li>
              <li>
                With service providers that support payments, analytics, hosting,
                and customer support.
              </li>
              <li>
                With legal authorities if required to comply with law or protect
                rights and safety.
              </li>
              <li>
                In connection with a merger, acquisition, or asset transfer, in
                which case we will provide notice where required.
              </li>
            </ul>
            <p className="mt-3">
              We do not sell your personal information.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              6. Data Retention
            </h2>
            <p className="mt-3">
              We retain information as long as needed to provide the Services,
              comply with legal obligations, resolve disputes, and enforce
              agreements. Retention periods vary based on the nature of the data
              and legal requirements.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">7. Security</h2>
            <p className="mt-3">
              We use reasonable administrative, technical, and physical measures
              to protect your information. No system is completely secure, and
              we cannot guarantee absolute security.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              8. International Transfers
            </h2>
            <p className="mt-3">
              Your information may be processed in countries other than your
              own. We take steps to ensure appropriate protections for
              cross-border transfers where required.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              9. Your Rights and Choices
            </h2>
            <p className="mt-3">
              Depending on your location, you may have rights to access,
              correct, delete, or export your information, and to object to or
              restrict certain processing. You can also opt out of marketing
              emails at any time.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">
              10. Children’s Privacy
            </h2>
            <p className="mt-3">
              The Services are not directed to children under 13, and we do not
              knowingly collect personal information from children. If we learn
              that we have collected such information, we will delete it.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">11. Changes</h2>
            <p className="mt-3">
              We may update this Privacy Policy from time to time. If we make
              material changes, we will provide notice through the Services or
              by other means as required by law.
            </p>
          </section>
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">12. Contact</h2>
            <p className="mt-3">
              To request access or deletion of your data, or to ask questions
              about this Policy, email{" "}
              <a className="text-[var(--hopp-gold)]" href="mailto:info@hopp.life">
                info@hopp.life
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
